import * as React from "react"
const DataSetIconDp = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#2FD4CF"
      d="M14 0c1.093 0 2 .907 2 2v12c0 1.093-.907 2-2 2H2c-1.093 0-2-.907-2-2V2C0 .907.907 0 2 0h12Zm1.385 13.538H.615V14a1.4 1.4 0 0 0 1.345 1.384H14A1.4 1.4 0 0 0 15.385 14v-.462Zm0-2.615H.615v2h14.77v-2Zm0-2.615H.615v2h14.77v-2Zm0-2.616H.615v2h14.77v-2Zm0-2.769H.615v2.154h14.77V2.923ZM14 .615H2A1.4 1.4 0 0 0 .615 2v.308h14.77V2A1.4 1.4 0 0 0 14.04.616H14Z"
    />
    <path
      fill="#E21824"
      fillOpacity={0.3}
      d="M2.923 2.615a.308.308 0 0 1 .308.308v12.77a.308.308 0 0 1-.616 0V2.922a.308.308 0 0 1 .308-.308Zm7.692 0a.308.308 0 0 1 .308.308v12.77a.308.308 0 0 1-.616 0V2.922a.308.308 0 0 1 .308-.308Zm2.462 0a.308.308 0 0 1 .307.308v12.77a.308.308 0 1 1-.615 0V2.922a.308.308 0 0 1 .308-.308Zm-7.693-.307a.308.308 0 0 1 .308.307v12.77a.308.308 0 0 1-.615 0V2.615a.308.308 0 0 1 .307-.307Zm2.616 0a.308.308 0 0 1 .308.307v12.77a.308.308 0 0 1-.616 0V2.615A.308.308 0 0 1 8 2.308Z"
    />
    <path
      fill="#E21824"
      fillOpacity={0.3}
      d="M15.693 2.615H.31C.462.923.77.308 2.462.308h10.924c1.846 0 2.307.615 2.307 2.307Z"
    />
  </svg>
)
export default DataSetIconDp
